import {API_URL} from "../config";
import axios from "../utils/axios";

class SettingRepository
{
    save(data) {
        return axios.post(API_URL + "/Setting/Save", data);
    }

    getAll(filter) {
        return axios.get(API_URL + "/Setting/List?", {params: filter});
    }

    getById(id) {
        return axios.get(API_URL + `/Setting/${id}`);
    }
}

export default SettingRepository;